import React from "react";
import PropTypes from "prop-types";
import CheckBox from "components/CheckBox";

const FarmCheckboxHeader = ({ isSelectedAllFarms, toggleFarms }) => {
  return (
    <div data-testid="farm-checkbox-header" className="farm-checkbox-header">
      <CheckBox
        data-testid="checkbox"
        defaultChecked={isSelectedAllFarms}
        onChange={() => toggleFarms()}
      />
    </div>
  );
};

FarmCheckboxHeader.defaultProps = {
  isSelectedAllFarms: false,
};

FarmCheckboxHeader.propTypes = {
  isSelectedAllFarms: PropTypes.bool,
  toggleFarms: PropTypes.func.isRequired,
};

export default FarmCheckboxHeader;
